/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    ICheckoutLoyaltyAdd, ICheckoutLoyaltyRewardPoint, ICheckoutLoyaltyShow,
    ICheckoutLoyaltyViewProps
} from './checkout-loyalty';

const AddCheckoutLoyalty: React.FC<ICheckoutLoyaltyAdd> = ({
    heading,
    cardNumber,
    drawer,
    rewardPoints,
    loyaltyAmountContainer,
    appliedLoyaltyAmountContainer,
    loyaltyAmountLabel,
    loyaltyAmountInput,
    loyaltyAmountApplyButton,
    showAppliedAmount,
    loyaltyAmountAppliedText,
    loyaltyAmountAppliedPrice,
    loyaltyAmountRemoveButton,
}) => {

    return (
        <>
            {heading}
            {cardNumber}
            <Node {...drawer}>
                {rewardPoints.map((rewardPoint: ICheckoutLoyaltyRewardPoint) => {
                    return (
                        <Node {...rewardPoint.checkoutLoyaltyRewardPoint} key={rewardPoint.key}>
                            {rewardPoint.title}
                            {rewardPoint.availablePointsText}
                            {rewardPoint.activePoints}
                            {rewardPoint.expiringPointsText}
                            {rewardPoint.expiringPoints}
                        </Node>
                    );
                })}
            </Node>
            <Node {...loyaltyAmountContainer}>
                {loyaltyAmountLabel}
                {loyaltyAmountInput}
                {loyaltyAmountApplyButton}
                {
                    showAppliedAmount &&
                        <Node {...appliedLoyaltyAmountContainer}>
                            {loyaltyAmountAppliedText}
                            {loyaltyAmountAppliedPrice}
                            {loyaltyAmountRemoveButton}
                        </Node>
                }
            </Node>
        </>
    );
};

const ShowCheckoutLoyalty: React.FC<ICheckoutLoyaltyShow> = ({
    heading,
    coveredAmountText,
    amount,
}) => {

    return (
        <>
            {heading}
            {coveredAmountText}
            {amount}
        </>
    );
};

const CheckoutLoyaltyView: React.FC<ICheckoutLoyaltyViewProps> = props => {
    const { checkoutLoyalty,
        viewState,
        showLoyalty,
        addLoyalty } = props;

    return (
        <Module {...checkoutLoyalty}>
            {viewState.isShowLoyalty && <ShowCheckoutLoyalty {...showLoyalty} />}
            {viewState.isShowAddLoyalty && <AddCheckoutLoyalty {...addLoyalty} />}
        </Module>
    );
};

export default CheckoutLoyaltyView;